import { Flex, FlexProps } from '@modusign/design-system';

interface WindowModalContentProps extends FlexProps<'div'> {}

const defaultProps = {
  px: 8,
  py: 8,
};

const WindowModalContent = (props: WindowModalContentProps) => (
  <Flex flexDirection="column" width="100%" {...props} />
);

WindowModalContent.defaultProps = defaultProps;

export default WindowModalContent;
